import graphql from "babel-plugin-relay/macro";
import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { useFragment } from "react-relay";

import { EventMetaInfo } from "../types";
import { EventDetailMetaInfoAtom } from "./";
import { useInitEventMeta_event$key } from "./__generated__/useInitEventMeta_event.graphql";

export const useInitEventMeta = ({
  fragmentRef,
}: {
  fragmentRef: useInitEventMeta_event$key | null;
}) => {
  const setEventDetailMetaInfo = useSetAtom(EventDetailMetaInfoAtom);
  const data = useFragment(useInitEventMetaFragmentString, fragmentRef);

  useEffect(() => {
    if (data) {
      const cancelAtWindows = data?.clientEligibleSignUpWindows?.filter(
        (suw) => {
          return !!suw?.cancelDeadlineAt;
        }
      );

      const meta: EventMetaInfo = {
        eventId: data.id,
        hasWaitlist: data?.hasWaitlist,
        accessStatusForClient: data?.accessStatusForClient,
        capacity: data?.capacity ?? null,
        spotsAvailable: data?.spotsAvailable,
        signUpWindowCancelDeadlineAt: cancelAtWindows?.[0]?.cancelDeadlineAt,
        memberSignUpProxyAllowed: data.memberSignUpProxyAllowed || false,
      };

      setEventDetailMetaInfo(meta);
    }
  }, [setEventDetailMetaInfo, data]);
};

export const useInitEventMetaFragmentString = graphql`
  fragment useInitEventMeta_event on Event {
    id
    capacity
    spotsAvailable
    hasWaitlist
    accessStatusForClient(clientId: $memberId)
    clientEligibleSignUpWindows(clientId: $memberId) {
      cancelDeadlineAt
    }
    memberSignUpProxyAllowed
  }
`;
